
import './input-toggle-group.css'
import ToggleInput from "./input-toggle.tsx";

export default function ToggleInputGroup<T>(props: {
	label: string,
  value: T | undefined,
	options: Array<{label: string, value: T, image: string}>,
  onChange: (key: T, value: boolean) => void,
}){
  return  <div className='toggle-input-group'>
            {props.options.map((option)=>
              <ToggleInput 
                key={option.label} 
                label={option.label} 
                image={option.image}
                value={option.value == props.value} 
                onChange={(checked:boolean)=>{
                    props.onChange(option.value, checked)
                }}/> 
            )}
          </div>
}
